// extracted by mini-css-extract-plugin
export default {"root":"SuccessModal_root__NSzzs","success":"SuccessModal_success__6z-qY"};